import * as React from "react";
import {
    UitkCard, 
    UitkHeading,
    UitkMessagingCard, 
    UitkMessagingCardActionTypes
} from "@egencia/uitk-react";

const quickLinksTitle = uitk.i18n.msg('quick_link_title');
const quickLinkItineraryTitle = uitk.i18n.msg('quick_links_itineray_title');
const quickLinkItinerary = uitk.i18n.msg('quick_links_itinerary');
const quickLinkReceiptsTitle = uitk.i18n.msg('quick_links_receipts_title');
const quickLinkReceipts = uitk.i18n.msg('quick_links_receipts');
const quickLinkProfileTitle = uitk.i18n.msg('quick_links_profile_title');
const quickLinkProfile = uitk.i18n.msg('quick_links_profile');

const tripsWebapp = "/trip-webapp/";
const usersProfile = "/users/profilerouter";
const hasBorder = false;

function handleClickManageTrips() {
    omnitureLog.logClickEvent(EG.pageName + '.ManageTrips.Clicked');
}

function handleClickManageReceipts() {
    omnitureLog.logClickEvent(EG.pageName + '.ManageReceipts.Clicked');
}

function handleClickManageProfile() {
    omnitureLog.logClickEvent(EG.pageName + '.ManageProfile.Clicked');
}

export const QuickLinks = () => {
    return (
        <UitkCard padding={"medium"} border={true}>
            <UitkHeading tag={"h2"} size={5}>{quickLinksTitle}</UitkHeading>
            <UitkMessagingCard
                className={"manage-trips-option"}
                icon={"work"}
                headingText={quickLinkItineraryTitle}
                textValue={quickLinkItinerary}
                border={hasBorder}
                action={UitkMessagingCardActionTypes.navigate}
                a11yActionLabel="continue"
                bodyUrl={tripsWebapp}
                onClickAction={handleClickManageTrips}
            />
            <UitkMessagingCard
                className={"view-receipts-option"}
                icon={"receipt"}
                headingText={quickLinkReceiptsTitle}
                textValue={quickLinkReceipts}
                border={hasBorder}
                action={UitkMessagingCardActionTypes.navigate}
                a11yActionLabel="continue"
                bodyUrl={tripsWebapp}
                onClickAction={handleClickManageReceipts}
            />
            <UitkMessagingCard
                className={"manage-profile-option"}
                icon={"account_circle"}
                headingText={quickLinkProfileTitle}
                textValue={quickLinkProfile}
                border={hasBorder}
                action={UitkMessagingCardActionTypes.navigate}
                a11yActionLabel="continue"
                bodyUrl={usersProfile}
                onClickAction={handleClickManageProfile}
            />
        </UitkCard>
    );
}